module.exports = __webpack_public_path__ + "img/image-5-p-800.556ce6f7.png";